import React from 'react';
import { ModalHeader, Button } from 'reactstrap';
import { Icon, UserAvatar } from '../Component';
import { getPublicDocumentUrl } from '../../utils/envConfig';
import { findUpper } from '../../utils/Utils';

/**
 * Chat Header Component
 * Displays user information and chat controls
 * 
 * @param {Object} props
 * @param {Object} props.user - The lead/user information
 * @param {Object} props.agent - The agent information
 * @param {Function} props.onClose - Function to close the modal
 */
const ChatHeader = ({ user, agent, onClose }) => {
    return (
        <ModalHeader
            toggle={onClose}
            className="text-white border-0"
        >
            <div className="d-flex align-items-center w-100">
                {/* User Avatar */}
                <div className="me-2">
                    <div
                        className="rounded-circle bg-white d-flex align-items-center justify-content-center position-relative"
                        style={{
                            width: '40px',
                            height: '40px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                        }}
                    >
                        {user?.photo ? (
                            <UserAvatar
                                image={getPublicDocumentUrl(user.photo)}
                                className="rounded-circle"
                                style={{ width: '36px', height: '36px' }}
                            />
                        ) : (
                            <UserAvatar
                                className="rounded-circle text-primary fw-bold"
                                text={findUpper(`${user?.first_name || ''} ${user?.last_name || ''}`)}
                                style={{
                                    width: '36px',
                                    height: '36px',
                                    fontSize: '14px',
                                    backgroundColor: '#f8f9fa'
                                }}
                            />
                        )}

                        {/* Online Status Indicator */}
                        <div
                            className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white"
                            style={{ width: '10px', height: '10px' }}
                            title="Online"
                        />
                    </div>
                </div>

                {/* User Info */}
                <div className="flex-grow-1 user-info">
                    <h6 className="mb-0 fw-bold text-white" style={{ fontSize: '1rem' }}>
                        {user?.first_name} {user?.last_name}
                    </h6>

                    <div className="d-flex align-items-center gap-3 mt-1">
                        {/* Agent Info */}
                        {agent?.first_name && (
                            <div className="d-flex align-items-center">
                                <Icon name="user" className="me-1" style={{ fontSize: '11px' }} />
                                <small className="text-white opacity-90" style={{ fontSize: '0.75rem' }}>
                                    with {agent.first_name} {agent.last_name}
                                </small>
                            </div>
                        )}

                        {/* Phone Number */}
                        {user?.phone && (
                            <div className="d-flex align-items-center">
                                <Icon name="phone" className="me-1" style={{ fontSize: '11px' }} />
                                <small className="text-white opacity-90" style={{ fontSize: '0.75rem' }}>
                                    {user.phone}
                                </small>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </ModalHeader>
    );
};

export default ChatHeader;